// extracted by extract-css-chunks-webpack-plugin
module.exports = {"editorHeader":"WRVGp","backButton":"_2CQyt"};